import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Crown, Download, Share2 } from "lucide-react";
import { toast } from "sonner";
import api, { reportApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const API = process.env.REACT_APP_BACKEND_URL;

export function WeekWinnerBanner() {
  const [w, setW] = useState(undefined);
  useEffect(() => { api.get("/leaderboard/week-winner").then((r) => setW(r.data.winner)).catch((e) => { reportApiError("WeekWinner")(e); setW(null); }); }, []);
  if (!w) return null;
  const url = `${API}${w.card_url}`;
  const share = async () => {
    try {
      const blob = await (await fetch(url)).blob();
      const file = new File([blob], "pitch-craft-week-winner.png", { type: "image/png" });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: "Pitch Craft Week Winner", text: `${w.name} topped the Pitch Craft World Leaderboard this week with ${w.xp.toLocaleString()} XP` });
      } else {
        await navigator.clipboard.writeText(url);
        toast.success("Card link copied", { description: "Paste it into LinkedIn, WhatsApp or Teams." });
      }
    } catch { window.open(url, "_blank"); }
  };
  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}
      className="rounded-3xl border border-amber-200 bg-gradient-to-r from-amber-50 via-white to-amber-50/60 p-4 sm:p-5 flex flex-wrap items-center gap-4 shadow-[0_10px_30px_-14px_rgba(245,158,11,0.45)]" data-testid="week-winner-banner">
      <div className="w-12 h-12 rounded-2xl bg-amber-400 text-black flex items-center justify-center shrink-0 shadow"><Crown className="w-6 h-6" /></div>
      <div className="flex-1 min-w-[220px]">
        <div className="text-[11px] font-bold uppercase tracking-widest text-amber-700">Last week's champion · {w.week_end}</div>
        <div className="text-base md:text-lg font-extrabold text-slate-900 font-display tracking-tight" data-testid="week-winner-name">
          {w.is_me ? "You" : w.name} topped the world with {w.xp.toLocaleString()} XP {w.is_me && <span className="ml-1 text-[10px] px-1.5 py-0.5 rounded bg-amber-400 text-black align-middle">WEEK WINNER BADGE EARNED</span>}
        </div>
        <div className="text-xs text-slate-500">{w.calls} roleplays · +100 bonus XP · {w.week_wins === 1 ? "first" : `${w.week_wins}th`} weekly title</div>
      </div>
      <div className="flex gap-2">
        <Button onClick={share} className="rounded-full h-10 px-4 bg-slate-900 hover:bg-slate-800 text-white font-semibold" data-testid="week-winner-share-btn"><Share2 className="w-4 h-4 mr-1.5" /> {w.is_me ? "Brag about it" : "Share card"}</Button>
        <a href={url} download="pitch-craft-week-winner.png" className="inline-flex items-center justify-center h-10 w-10 rounded-full border border-slate-300 bg-white text-slate-700 hover:bg-slate-50" title="Download card" data-testid="week-winner-download-btn"><Download className="w-4 h-4" /></a>
      </div>
    </motion.div>
  );
}
